<tlk-modal-header [id]="'modal-header'" header>
	{{ data.titleTranslationKey | translate }}
	<button tlkButton variant="ghost" size="l" right-icon data-testid="confirmation-dialog-close" (click)="closeWithAction(popUpActions.Cancel)"><tlk-close-empty-icon class="tlk-icon_size_l"/></button>
</tlk-modal-header>
<tlk-modal-content content>
	<div class="dialog-content">{{ data.contentTranslationKey | translate }}</div>
</tlk-modal-content>
<tlk-modal-footer footer>
	<ng-container ngProjectAs="[right-buttons]">
		<button tlkButton variant="secondary" size="m" data-testid="confirmation-dialog-cancel" (click)="closeWithAction(popUpActions.Cancel)">
			{{ (data.cancelTranslationKey || 'Popup.Cancel') | translate }}
		</button>
		<button tlkButton variant="primary" size="m" data-testid="confirmation-dialog-confirm" (click)="closeWithAction(popUpActions.Ok)">
			{{ (data.confirmTranslationKey || 'Popup.OK') | translate }}
		</button>
	</ng-container>
</tlk-modal-footer>
